// extracted by css-extract-rspack-plugin
export default {"date":"DateOn__date--soKsO"};